module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "arrow-up-green.9cbe82f7.png";